import { render, staticRenderFns } from "./ReviewModalAddEditRestaurant.vue?vue&type=template&id=2998aeae&scoped=true&"
import script from "./ReviewModalAddEditRestaurant.vue?vue&type=script&lang=js&"
export * from "./ReviewModalAddEditRestaurant.vue?vue&type=script&lang=js&"
import style0 from "./ReviewModalAddEditRestaurant.vue?vue&type=style&index=0&id=2998aeae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2998aeae",
  null
  
)

export default component.exports